const factoringBannerContainer = {
  padding: '1.5rem 2rem 3rem 2rem',
  gap: '0.625rem',
  alignSelf: 'stretch',
  background: 'white',
};

const bannerStack = (theme) => ({
  borderRadius: '2rem',
  width: '100%',
  maxWidth: '100rem',
  gap: '1rem',
  backgroundColor: theme.palette.contrast.A700,
  overflow: 'hidden',
});

const contentStack = {
  justifyContent: 'space-between',
  padding: { xs: '3.5rem 2rem', phone: '3.5rem 4.5rem' },
  gap: '2rem',
  width: { xs: '100%', m: '60%' },
};

const titleTypography = {
  color: 'white',
  fontSize: { xs: '1.5rem', sm: '2.5rem' },
};

const subtitleTypography = {
  color: 'white',
  fontSize: { xs: '1rem', phone: '1.25rem' },
};

const imageContainer = {
  display: { xs: 'none', m: 'flex' },
};

const imageStyles = {
  objectFit: 'contain',
  maxWidth: '25rem',
  maxHeight: '20rem',
  height: '100%',
  width: '100%',
  transform: 'scale(1.3) translateX(12%) translateY(5%)',
};

export {
  factoringBannerContainer,
  bannerStack,
  contentStack,
  titleTypography,
  subtitleTypography,
  imageContainer,
  imageStyles,
};
